import { render, staticRenderFns } from "./SelectAdditionalBenefits.vue?vue&type=template&id=30c3c010"
import script from "./SelectAdditionalBenefits.vue?vue&type=script&lang=js"
export * from "./SelectAdditionalBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports